<template>
  <v-dialog v-model="kpi" fullscreen hide-overlay transition="dialog-bottom-transition" >
    <v-card v-if="kpi">
      <v-toolbar dark color="primary">
        <v-scale-transition>
          <v-btn v-if="!menu" fab small color="secondary" bottom left absolute @click="menu = true">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </v-scale-transition>
        <v-spacer></v-spacer>
        <v-toolbar-title>Kpi</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="kpi = false; $router.replace('/');">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-row class="flex-no-wrap">
            <v-col v-if="menu" cols="3">
              <v-card >
                <v-toolbar dense color="primary" dark>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>Menu</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="menu = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-list>
                  <v-list-item to="/resume">
                    <v-list-item-icon>
                      <v-icon>mdi-table-large</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('stats.resume')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item to="/orders">
                    <v-list-item-icon>
                      <v-icon>mdi-chart-bar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('stats.orders')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item to="/stock-delay">
                    <v-list-item-icon>
                      <v-icon>mdi-chart-bar-stacked</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('stats.stockDelay')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item to="/cost">
                    <v-list-item-icon>
                      <v-icon>mdi-chart-bar-stacked</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('stats.cost')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item to="/buffer" v-if="$store.getters['company/ddOn']">
                    <v-list-item-icon>
                      <v-icon>mdi-chart-bar-stacked</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>{{$t('stats.buffers')}}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          <v-col :cols="menu ? '9' : '12'">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "Kpi",
  components: {},
  data() {
    return {
      menu: true
    };
  },
  mounted() {},
  methods: {},
  computed: {
    kpi: {
      get() {
        return this.$store.state.interfaceSettings.kpi;
      },
      set(newValue) {
        this.$store.commit("interfaceSettings/SET_kpi", newValue);
      }
    }
  }
};
</script>

